import * as z from "zod";

export const importKnowledgeCsv = {
  name: "importKnowledgeCsv" as const,
  input: z.object({}),
  output: z.object({
    createdCount: z.number().int().nonnegative(),
    skippedDuplicates: z.array(z.string()),
    parseErrors: z.array(
      z.object({ row: z.number().int().positive(), reason: z.string() }),
    ),
  }),
};
